
























import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import cms from '@/store/modules/cms';
import store from '@/store';
import { Agreement } from '@/store/models';
import { Validator } from 'vee-validate';
import ui from '@/store/modules/ui';
import Modal from '@/components/UI/Modal.vue';

@Component({
    components: {
        Modal,
    },
})
export default class CmsAgreement extends Vue {
    @Inject() public $validator!: Validator;
    @Prop() private name!: string;
    @Prop() private combo!: boolean;
    @Prop() private validation!: string;

    get agreement(): Agreement {
        const blankAgreement = {
            id: 0,
            name: '',
            label: '',
            content: '',
            validate_name: '',
            approved: false,
            required: false,
        };
        if (!cms.hasAgreements) {
            return blankAgreement;
        }
        if (this.combo) {
            if (store.state.options && store.state.options.combo_agreements) {
                return cms.agreementByName(store.state.options.combo_agreements[this.name][0]);
            }
            return blankAgreement;
        }
        const ag = cms.agreementByName(this.name);
        if (!ag) {
            return blankAgreement;
        }

        return ag;
    }

    get label(): string {
        if (this.combo) {
            const comboConfig = store.state.options.combo_agreements[this.name];
            let label = '';
            for (const c of comboConfig) {
                label += cms.agreementByName(c).label;
            }
            return label;
        }
        return this.agreement.label;
    }

    get identifier(): string {
        return this.name.replace(/\s/g, '').toLowerCase();
    }

    get content(): string {
        if (this.combo) {
            const comboConfig = store.state.options.combo_agreements[this.name];
            let content = '';
            for (const c of comboConfig) {
                content += cms.agreementByName(c).content + '<br/><br/>';
            }
            return content;
        }
        return this.agreement.content;
    }

    get isRequired(): boolean {
        return this.agreement && this.agreement.required;
    }

    get validationRule(): string {
        // Do we have an overridden validator? If yes, use that.
        if (this.validation) {
            return this.validation;
        }

        let rule = '';

        if (this.isRequired) {
            rule += 'required';
        }

        return rule;
    }

    get agreementApproved() {
        return this.agreement ? this.agreement.approved : false;
    }

    set agreementApproved(value) {
        cms.setAgreementFlag({agreement: this.agreement, flag: value});
    }

    get validateName() {
      // Do we have an overridden validator? If yes, use that.
      if (this.validation) {
          return this.validation;
      }

      return this.agreement.validate_name;
    }

    private openModal(id: string) {
        ui.openModal(id);
    }

    private closeModal(id: string) {
        ui.closeModal(id);
    }
}
